import { render, staticRenderFns } from "./listaAdiantamento.vue?vue&type=template&id=70c87590"
import script from "./listaAdiantamento.vue?vue&type=script&lang=js"
export * from "./listaAdiantamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports